import { Ellipsis } from 'lucide-react-native';
import { memo, useState } from 'react';
import { BiButton } from '../../components/ui/BiButton';
import { BiCardMoves, CardMenu } from './CardMenu';

/** The ⋯ on a card's header and the menu it opens. */
export const CardMenuButton = memo(
  ({
    title,
    onOpen,
    onRefresh,
    onCopy,
    onEdit,
    editDisabled,
    moves,
    onRemove,
  }: {
    title: string;
    onOpen: () => void;
    onRefresh: () => void;
    onCopy?: () => void;
    onEdit?: () => void;
    editDisabled?: boolean;
    moves?: BiCardMoves;
    onRemove?: () => void;
  }) => {
    const [open, setOpen] = useState(false);
    return (
      <>
        <BiButton
          icon={Ellipsis}
          tone="quiet"
          accessibilityLabel={`更多 ${title}`}
          onPress={() => setOpen(true)}
        />
        <CardMenu
          visible={open}
          title={title}
          onOpen={onOpen}
          onRefresh={onRefresh}
          onCopy={onCopy}
          onEdit={onEdit}
          editDisabled={editDisabled}
          moves={moves}
          onRemove={onRemove}
          onClose={() => setOpen(false)}
        />
      </>
    );
  },
);
